"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDocumentNotaryStatus = void 0;
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const _1 = __importDefault(require("."));
const Customer_1 = __importDefault(require("./Customer"));
const Resource_1 = __importDefault(require("../Resource"));
const File_1 = __importDefault(require("./File"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const DocumentNotaryAnchor_1 = __importDefault(require("./DocumentNotaryAnchor"));
class DocumentNotary extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = DocumentNotary;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createFile"], message: "UID is required" }),
    __metadata("design:type", String)
], DocumentNotary.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentNotary.prototype, "document", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", OfficeFolder_1.default)
], DocumentNotary.prototype, "folder", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => _1.default),
    __metadata("design:type", _1.default)
], DocumentNotary.prototype, "depositor", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Customer_1.default)
], DocumentNotary.prototype, "customer", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentNotary.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], DocumentNotary.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => File_1.default),
    __metadata("design:type", Array)
], DocumentNotary.prototype, "files", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], DocumentNotary.prototype, "document_status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, classTransformer_1.Type)(() => DocumentNotaryAnchor_1.default),
    __metadata("design:type", Object)
], DocumentNotary.prototype, "document_notary_anchor", void 0);
var EDocumentNotaryStatus;
(function (EDocumentNotaryStatus) {
    EDocumentNotaryStatus["SENT"] = "SENT";
    EDocumentNotaryStatus["DOWNLOADED"] = "DOWNLOADED";
})(EDocumentNotaryStatus || (exports.EDocumentNotaryStatus = EDocumentNotaryStatus = {}));
